import React from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { separate } from "../../Seprate/Seprate";
import NumberOrderDetail from "../NumberOrderDetail/NumberOrderDetail";
import Style from "../SupermarketList/SupermarketList.module.css";
import { Link } from "react-router-dom";

const SupermarketList = ({ data, update }) => {
  return (
    <ul className={Style.ListHolder}>
      {data.suppliers.map((item, index) => {
        return (
          <li key={index} className={Style.StoreInfo}>
            <Link
              to={`/supplier/${item.supplier_id}/`}
              className={Style.ImageHolder}
            >
              <img
                src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`}
                alt="رستوران"
              />
            </Link>
            <div className={Style.StoreInfoHolder}>
              <h4 className={Style.StoreNameHolder}>{item.name}</h4>
              <div className={Style.priceHolder}>
                <h3
                  className={
                    item.off_price === "0" ? Style.noOffPrice : Style.offPrice
                  }
                >
                  <span>{separate(item.off_price)}</span>تومان
                </h3>
                <h3
                  className={
                    item.off_price === "0" ? Style.noprice : Style.price
                  }
                >
                  <span>{separate(item.price)}</span>تومان
                </h3>
              </div>
              <div className={Style.StoreRate}>
                <div className={Style.FixRate}>
                  <div className={Style.RateHolder}>
                    <div className={Style.grayStar}>
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                    </div>
                    <div
                      className={Style.GoldStar}
                      style={{ width: `${item.supplier_rate * 20}%` }}
                    >
                      <div className={Style.GoldStarHolder}>
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                      </div>
                      <div
                        className={Style.GoldStar}
                        style={{ width: `${item.supplier_rate * 20}%` }}
                      >
                        <div className={Style.GoldStarHolder}>
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={Style.counterHolder}>
                <NumberOrderDetail
                  dataUpdate={update}
                  supId={item.supplier_id}
                  data={item}
                />
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default SupermarketList;
